<template>
	<div>
		<router-link v-if="canWrite('spinners')" :to="{
			name: 'projects-editor-uuid-cuuid-tests-reports-new',
			params: {
				uuid: $route.params.uuid,
			   cuuid: $route.params.cuuid
			}
		}" class="btn btn-link my-2">
			<i class="fa fa-plus"></i>
			NEW REPORT
		</router-link>

		<div class="my-2">

			<table class="table table-hover">
				<thead>
				<tr>
					<td>ID</td>
					<td>Date/time</td>
					<td>Version</td>
					<td>Status</td>
					<td>Type</td>
					<td>Bet</td>
					<td>Lines</td>
					<td>Spins</td>
					<td>RTP</td>
					<td></td>
				</tr>
				</thead>
				<tbody>
				<router-link class="cursor-pointer" :to="{
					name: 'projects-editor-uuid-cuuid-tests-reports-report_id',
					params: {
						report_id: report.Id
					}
				}" tag="tr" v-for="report in reports" :key="report.Id">
					<td v-text="report.Id"></td>
					<td v-rel-date="report.CreatedAt"></td>
					<td v-text="report.Version"></td>
					<td>
						<spinner-status-label :status="report.Status"></spinner-status-label>
						<div class="mt-1 p-2 bg-light text-nowrap text-truncate" style="max-width: 200px"
							 v-text="report.Notes" :title="report.Notes" v-if="report.Notes"></div>
					</td>
					<td v-text="report.Type"></td>
					<td v-text="report.Bet"></td>
					<td>
						<div class="badge text-uppercase" v-for="payline in report.Paylines">{{payline}}</div>
					</td>
					<td>
						<div class="badge text-uppercase" v-for="spin in report.Spins"
							 v-if="report.Type === 'standard'">{{spin|numeral('Oa')}}
						</div>
						<div class="badge text-uppercase"
							 v-if="report.Type === 'stress'">{{report.Spins[0]|numeral('Oa')}} x
							{{report.Spins[1]|numeral('Oa')}} spins
						</div>
					</td>
					<td>
						<!--
						<div class="progress">
							<div class="progress-bar"
								 :class="report.Status === 'running' ? 'progress-bar-animated progress-bar-striped': null"
								 :style="{width: `${Math.round(report.NbSpinnerTestsDone / report.NbSpinnerTests * 100)}%`}"></div>
						</div>
						-->

						<template v-if="report.Summary.balance.total_bet">
							{{report.Summary.balance.total_win / report.Summary.balance.total_bet | numeral('0.00%')}}
						</template>

						<div class="text-small">{{report.NbSpinnerTests - report.NbSpinnerTestsDone}} tests left</div>
					</td>
					<td>
						<div class="d-flex flex-nowrap">
							<report-excel-download-button class="btn btn-link btn-primary"
														  :report="report"></report-excel-download-button>
							<button :disabled="deleting" class="btn btn-link btn-danger"
									@click.prevent.stop="deleteReport(report.Id)" v-if="canWrite('spinners')">
								<i class="fa fa-trash"></i>
							</button>
						</div>
					</td>
				</router-link>
				</tbody>
			</table>

		</div>

	</div>
</template>

<script>
	import api from '@/api'
	import SpinnerStatusLabel from '@/components/spinner/spinner-status-label'
	import ReportExcelDownloadButton from "../../../../../../../components/reports/report-excel-download-button";
	import messageBox from '@/components/modals/alert'

	export default {
		data() {
			return {
				reports: [],
				interval: null,
				deleting: false
			}
		},
		async mounted() {
			this.loadReports()
			this.interval = setInterval(this.loadReports, 10000)
		},
		destroyed() {
			clearInterval(this.interval)
		},
		methods: {
			async loadReports() {
				this.reports = await api.Reports.getList(this.$route.params.cuuid)
			},
			async deleteReport(report_id) {
				this.deleting = true
				await api.Reports.delete(report_id).catch(() => this.deleting = false)
				await this.loadReports()
				this.deleting = false
				messageBox({
					message: `Report deleted!`
				})

			}
		},
		components: {
			ReportExcelDownloadButton,
			SpinnerStatusLabel
		}
	}
</script>
